<template>
  <div
    v-show="shouldDisplay"
    class="landing-sticky-mobile-cta"
  >
    <div class="landing-sticky-mobile-cta__inner">
      <BaseButton
        :text="ctaBtnTitle"
        class="landing-sticky-mobile-cta__button"
        @click="handleCTAButtonClick"
      />
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { debounce } from '@shared/utils'
import BaseButton from '@shared/components/BaseButton.vue'

const props = defineProps({
  ctaBtnTitle: {
    type: String,
    default: '',
  },
  handleCTAButtonClick: {
    type: Function,
    default: () => {},
  },
  showStickyCta: {
    type: Function,
    default: () => false,
  },
})

const shouldDisplay = ref(false)
const debounceHandleScroll = ref(null)

const handleScroll = () => {
  shouldDisplay.value = props.showStickyCta()
}

onMounted(() => {
  debounceHandleScroll.value = debounce(handleScroll, 10)
  window.addEventListener('scroll', debounceHandleScroll.value)
  window.addEventListener('resize', debounceHandleScroll.value)
  shouldDisplay.value = props.showStickyCta()
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', debounceHandleScroll.value)
  window.removeEventListener('resize', debounceHandleScroll.value)
  debounceHandleScroll.value = null
})
</script>

<style lang="scss" scoped>
.landing-sticky-mobile-cta {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  background: $kds-color-background-base;
  box-shadow: 0 -2px 2px rgba(10, 28, 64, 0.1);
  padding: $kds-space-1_5x $kds-space-1_5x
    calc($kds-space-1_5x + env(safe-area-inset-bottom, 0px));

  &__inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }

  &__button {
    width: 80%;
    max-width: 340px;
  }
}
</style>
